import React, {useContext, useMemo} from 'react'
import styled, {ThemeContext} from 'styled-components'

import {Link} from 'react-router-dom'
import {white} from "../../theme/colors";

export interface ButtonProps {
    children?: React.ReactNode,
    disabled?: boolean,
    href?: string,
    onClick?: (ev: any) => void,
    size?: 'sm' | 'md' | 'lg',
    text?: string,
    to?: string,
    color?:string,
    bGColor?:string,
    variant?: 'default' | 'secondary' | 'tertiary',
    borderColor?:string
}

const Button: React.FC<ButtonProps> = ({
                                           children,
                                           disabled,
                                           href,
                                           onClick,
                                           size,
                                           text,
                                           to,
                                           variant,
                                           color = '#ffffff',
                                           bGColor = 'RGBA(27, 82, 138, 1)',
                                           borderColor
                                       }) => {
    const {spacing} = useContext(ThemeContext);

    let buttonColor: string;
    switch (variant) {
        case 'secondary':
            buttonColor = color;
            break;
        case 'default':
        default:
            buttonColor = color
    }

    let buttonSize: number;
    let buttonPadding: number;
    let fontSize: number;
    switch (size) {
        case 'sm':

            buttonPadding = 30;
            buttonSize = 36;
            fontSize = 14;
            break;
        case 'lg':

            buttonPadding = spacing[4];
            buttonSize = 72;
            fontSize = 16;
            break;
        case 'md':
        default:
            buttonPadding = spacing[4];
            buttonSize = 40;
            fontSize = 16
    }

    const ButtonChild = useMemo(() => {
        if (to) {
            return <StyledLink to={to}>{text}</StyledLink>
        } else if (href) {
            return <StyledExternalLink href={href} target="__blank">{text}</StyledExternalLink>
        } else {
            return text
        }
    }, [href, text, to]);

    return (
        <StyledButton
            color={buttonColor}
            bGColor={bGColor}
            disabled={disabled}
            fontSize={fontSize}
            onClick={(e) => onClick(e)}
            padding={buttonPadding}
            size={buttonSize}
            borderColor={borderColor}
        >
            {children}
            {ButtonChild}
        </StyledButton>
    )
};

export interface StyledButtonProps {
    boxShadow?: string,
    color: string,
    disabled?: boolean,
    fontSize: number,
    padding: number,
    size: number,
    bGColor?:string,
    borderColor?:string
}

const StyledButton = styled.button<StyledButtonProps>`
  align-items: center;
  background:${(props)=> props.bGColor || 'RGBA(27, 82, 138, 1)'} ;
  border: 1px solid ${(props)=>props.borderColor ||'RGBA(46, 162, 248, 1)'};
  border-radius: 5px;
  
  color: ${props => !props.disabled ? props.color : `${props.color}55`};
  cursor: pointer;
  display: flex;
  font-size: ${props => props.fontSize}px;
  font-weight: 700;
  height: ${props => props.size}px;
  justify-content: center;
  outline: none;
  padding-left: ${props => props.padding}px;
  padding-right: ${props => props.padding}px;
  pointer-events: ${props => !props.disabled ? undefined : 'none'};
  width: 100%;
  &:hover {
    // background-color: ${props => props.theme.color.grey[100]};
  }
`;

const StyledLink = styled(Link)`
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1;
  height: 56px;
  justify-content: center;
  margin: 0 ${props => -props.theme.spacing[4]}px;
  padding: 0 ${props => props.theme.spacing[4]}px;
  text-decoration: none;
`;

const StyledExternalLink = styled.a`
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1;
  height: 56px;
  justify-content: center;
  margin: 0 ${props => -props.theme.spacing[4]}px;
  padding: 0 ${props => props.theme.spacing[4]}px;
  text-decoration: none;
`;

export default Button
